import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UninvitedUserVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveUninvitedUsers = createAsyncThunk<UninvitedUserVM[], void, { extra: Partial<Dependencies> }>(
  "users/retrieveUninvitedUsers",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listUninvitedUsers();
  },
);
